import React, { useState } from "react";
import gregorian_en from "react-date-object/locales/gregorian_en";
import { FormattedMessage, IntlShape, useIntl } from 'react-intl';
import DatePicker, { DateObject } from "react-multi-date-picker";
import { Flex, Box, Button } from 'theme-ui';
import { de_calender } from "./data";

/** @jsx jsx */
import { jsx } from 'theme-ui';

interface MultipleDateRangeProps {
  onChange: (ranges: string[]) => void;
  value?: string[];
  placeholder?: string;
}

export const MultipleDateRange: React.FC<MultipleDateRangeProps> = ({onChange, value=[], placeholder=""}) => {
  const intl: IntlShape = useIntl();
  const locale = intl.locale;
  const [rangeTags, setRangeTags] = useState<string[]>(value);
  const [datePickerState, setDatePickerState] = useState<DateObject[]>([]);

  const deleteRange = (index: number) => {
    setRangeTags((prevState: string[]) => {
      const newState = prevState.filter((ranges, i) => i !== index);
      onChange(newState);
      return newState;
    }
    );
  };

  return (
    <Box className="multi-date-range-picker"
      sx={{
        ".rmdp-container": {
          minWidth: '205px',
          width: '100%'
        },
        ".rmdp-input": {
          variant: 'forms.input',
          height: 'inherit',
          width: '100%',
          fontSize: 'inherit'
        },
        ".rmdp-range": {
          backgroundColor: 'primary'
        },
        ".rmdp-today .sd, .rmdp-day.rmdp-today span": {
          backgroundColor: 'secondary',
        },
        ".rmdp-day.rmdp-selected span:not(.highlight)": {
          backgroundColor: 'primary',
        },
        ".rmdp-week-day": {
          color: 'primary',
        },
        ".rmdp-day:not(.rmdp-disabled):not(.rmdp-day-hidden) span.sd:hover": {
          backgroundColor: 'darker',
        },
        ".rmdp-day:not(.rmdp-disabled):not(.rmdp-day-hidden) span:hover": {
          backgroundColor: 'darker'
        },
        ".rmdp-arrow": {
          borderColor: 'primary'
        },
        ".rmdp-arrow-container:hover": {
          backgroundColor: 'darker',
          boxShadow: 'none'
        }
    }}>
      <Flex className="tags"
        sx={{
          flexWrap: 'wrap'
        }}>
        {rangeTags.map((range, index) => (
          <span className="tag" key={index}
            sx={{
              color: 'white',
              backgroundColor: 'darker',
              py: '2px',
              px: '8px',
              mr: '4px',
              mb: '4px'
            }}>
            {range}
            <a onClick={() => deleteRange(index)}
              sx={{
                cursor: 'pointer',
                paddingLeft: '6px',
                color: 'white',
                position: 'relative',
                top: '-1px'
              }}>
            x</a>
          </span>
        ))}
      </Flex>
      <DatePicker
        range
        weekStartDayIndex={1}
        placeholder={placeholder}
        value={datePickerState}
        locale={locale.startsWith('de') ? de_calender : gregorian_en}
        format={"YYYY-MM-DD"}
        onChange={(selectedValue: DateObject[]) =>
          setDatePickerState(selectedValue)
        }
      >
        <Button
          sx={{ m: "5px" }}
          onClick={() => {
            setRangeTags((prevState: string[]) => {
              if (datePickerState.length === 1) {
                prevState.push(datePickerState[0].format("YYYY-MM-DD"));
              }
              else if (datePickerState.length === 2) {
                prevState.push(
                  datePickerState[0].format("YYYY-MM-DD") +
                    " ~ " +
                    datePickerState[1].format("YYYY-MM-DD")
                );
              }
              onChange(prevState);
              return prevState;
            });
            setDatePickerState([]);
          }}
        >
          <FormattedMessage id="button.ok" />
        </Button>
      </DatePicker>
    </Box>
  );
};
